/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * ChatAgent.Api
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CreateCheckoutSessionRequest
} from '.././model';

import { customInstance } from '../../client';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const postApiWorkspacesWorkspaceIdBillingCreateCheckoutSession = (
    workspaceId: string,
    createCheckoutSessionRequest: CreateCheckoutSessionRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/workspaces/${workspaceId}/billing/create-checkout-session`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createCheckoutSessionRequest, signal
    },
      options);
    }
  


export const getPostApiWorkspacesWorkspaceIdBillingCreateCheckoutSessionMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiWorkspacesWorkspaceIdBillingCreateCheckoutSession>>, TError,{workspaceId: string;data: CreateCheckoutSessionRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiWorkspacesWorkspaceIdBillingCreateCheckoutSession>>, TError,{workspaceId: string;data: CreateCheckoutSessionRequest}, TContext> => {

const mutationKey = ['postApiWorkspacesWorkspaceIdBillingCreateCheckoutSession'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiWorkspacesWorkspaceIdBillingCreateCheckoutSession>>, {workspaceId: string;data: CreateCheckoutSessionRequest}> = (props) => {
          const {workspaceId,data} = props ?? {};

          return  postApiWorkspacesWorkspaceIdBillingCreateCheckoutSession(workspaceId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiWorkspacesWorkspaceIdBillingCreateCheckoutSessionMutationResult = NonNullable<Awaited<ReturnType<typeof postApiWorkspacesWorkspaceIdBillingCreateCheckoutSession>>>
    export type PostApiWorkspacesWorkspaceIdBillingCreateCheckoutSessionMutationBody = CreateCheckoutSessionRequest
    export type PostApiWorkspacesWorkspaceIdBillingCreateCheckoutSessionMutationError = unknown

    export const usePostApiWorkspacesWorkspaceIdBillingCreateCheckoutSession = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiWorkspacesWorkspaceIdBillingCreateCheckoutSession>>, TError,{workspaceId: string;data: CreateCheckoutSessionRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiWorkspacesWorkspaceIdBillingCreateCheckoutSession>>,
        TError,
        {workspaceId: string;data: CreateCheckoutSessionRequest},
        TContext
      > => {

      const mutationOptions = getPostApiWorkspacesWorkspaceIdBillingCreateCheckoutSessionMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const postApiWorkspacesWorkspaceIdBillingCreatePortalSession = (
    workspaceId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/workspaces/${workspaceId}/billing/create-portal-session`, method: 'POST', signal
    },
      options);
    }
  


export const getPostApiWorkspacesWorkspaceIdBillingCreatePortalSessionMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiWorkspacesWorkspaceIdBillingCreatePortalSession>>, TError,{workspaceId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiWorkspacesWorkspaceIdBillingCreatePortalSession>>, TError,{workspaceId: string}, TContext> => {

const mutationKey = ['postApiWorkspacesWorkspaceIdBillingCreatePortalSession'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiWorkspacesWorkspaceIdBillingCreatePortalSession>>, {workspaceId: string}> = (props) => {
          const {workspaceId} = props ?? {};

          return  postApiWorkspacesWorkspaceIdBillingCreatePortalSession(workspaceId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiWorkspacesWorkspaceIdBillingCreatePortalSessionMutationResult = NonNullable<Awaited<ReturnType<typeof postApiWorkspacesWorkspaceIdBillingCreatePortalSession>>>
    
    export type PostApiWorkspacesWorkspaceIdBillingCreatePortalSessionMutationError = unknown

    export const usePostApiWorkspacesWorkspaceIdBillingCreatePortalSession = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiWorkspacesWorkspaceIdBillingCreatePortalSession>>, TError,{workspaceId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiWorkspacesWorkspaceIdBillingCreatePortalSession>>,
        TError,
        {workspaceId: string},
        TContext
      > => {

      const mutationOptions = getPostApiWorkspacesWorkspaceIdBillingCreatePortalSessionMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getApiWorkspacesWorkspaceIdBillingStatus = (
    workspaceId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/workspaces/${workspaceId}/billing/status`, method: 'GET', signal
    },
      options);
    }
  



export const getGetApiWorkspacesWorkspaceIdBillingStatusQueryKey = (workspaceId?: string,) => {
    return [
    `/api/workspaces/${workspaceId}/billing/status`
    ] as const;
    }

    
export const getGetApiWorkspacesWorkspaceIdBillingStatusQueryOptions = <TData = Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdBillingStatus>>, TError = unknown>(workspaceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdBillingStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiWorkspacesWorkspaceIdBillingStatusQueryKey(workspaceId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdBillingStatus>>> = ({ signal }) => getApiWorkspacesWorkspaceIdBillingStatus(workspaceId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(workspaceId),  staleTime: 10000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdBillingStatus>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetApiWorkspacesWorkspaceIdBillingStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdBillingStatus>>>
export type GetApiWorkspacesWorkspaceIdBillingStatusQueryError = unknown


export function useGetApiWorkspacesWorkspaceIdBillingStatus<TData = Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdBillingStatus>>, TError = unknown>(
 workspaceId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdBillingStatus>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdBillingStatus>>,
          TError,
          Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdBillingStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetApiWorkspacesWorkspaceIdBillingStatus<TData = Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdBillingStatus>>, TError = unknown>(
 workspaceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdBillingStatus>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdBillingStatus>>,
          TError,
          Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdBillingStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetApiWorkspacesWorkspaceIdBillingStatus<TData = Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdBillingStatus>>, TError = unknown>(
 workspaceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdBillingStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetApiWorkspacesWorkspaceIdBillingStatus<TData = Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdBillingStatus>>, TError = unknown>(
 workspaceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdBillingStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetApiWorkspacesWorkspaceIdBillingStatusQueryOptions(workspaceId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const postApiWebhooksStripe = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/webhooks/stripe`, method: 'POST', signal
    },
      options);
    }
  


export const getPostApiWebhooksStripeMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiWebhooksStripe>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiWebhooksStripe>>, TError,void, TContext> => {

const mutationKey = ['postApiWebhooksStripe'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiWebhooksStripe>>, void> = () => {
          

          return  postApiWebhooksStripe(requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiWebhooksStripeMutationResult = NonNullable<Awaited<ReturnType<typeof postApiWebhooksStripe>>>
    
    export type PostApiWebhooksStripeMutationError = unknown

    export const usePostApiWebhooksStripe = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiWebhooksStripe>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiWebhooksStripe>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getPostApiWebhooksStripeMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getApiBillingPlans = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/billing/plans`, method: 'GET', signal
    },
      options);
    }
  



export const getGetApiBillingPlansQueryKey = () => {
    return [
    `/api/billing/plans`
    ] as const;
    }

    
export const getGetApiBillingPlansQueryOptions = <TData = Awaited<ReturnType<typeof getApiBillingPlans>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiBillingPlans>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiBillingPlansQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiBillingPlans>>> = ({ signal }) => getApiBillingPlans(requestOptions, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 10000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiBillingPlans>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetApiBillingPlansQueryResult = NonNullable<Awaited<ReturnType<typeof getApiBillingPlans>>>
export type GetApiBillingPlansQueryError = unknown


export function useGetApiBillingPlans<TData = Awaited<ReturnType<typeof getApiBillingPlans>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiBillingPlans>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiBillingPlans>>,
          TError,
          Awaited<ReturnType<typeof getApiBillingPlans>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetApiBillingPlans<TData = Awaited<ReturnType<typeof getApiBillingPlans>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiBillingPlans>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiBillingPlans>>,
          TError,
          Awaited<ReturnType<typeof getApiBillingPlans>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetApiBillingPlans<TData = Awaited<ReturnType<typeof getApiBillingPlans>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiBillingPlans>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetApiBillingPlans<TData = Awaited<ReturnType<typeof getApiBillingPlans>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiBillingPlans>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetApiBillingPlansQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



